import styled from '@emotion/styled'

import { mq } from '@/lib/responsive'

export const Markdown = styled.div`
  display: grid;
  grid-template-columns: 100%;
  gap: 16px;
  color: #1a1a1a;
  font-size: 16px;
  letter-spacing: 0.54px;
  word-break: break-word;
  margin-bottom: 36px;
  font-family: -apple-system, blinkmacsystemfont, Segoe UI, roboto, oxygen-sans,
    ubuntu, cantarell, Helvetica Neue, helvetica, arial, sans-serif;

  p {
    font-weight: 300;
    line-height: 1.7;
  }

  hr {
    display: block;
    width: 100%;
    max-width: 360px;
    margin: 0 auto;
    border: none;
    border-bottom: 1px solid #d8d8d8;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: Anakotmai;
  }

  h1 {
    font-size: 36px;

    ${mq('sm')} {
      font-size: 40px;
    }
  }

  h2 {
    font-size: 28px;
    margin-top: 28px;

    ${mq('sm')} {
      font-size: 32px;
    }
  }

  h3 {
    font-size: 20px;
    margin-top: 28px;

    ${mq('sm')} {
      font-size: 24px;
    }
  }

  h4 {
    font-size: 18px;
    margin-top: 28px;

    ${mq('sm')} {
      font-size: 20px;
    }
  }

  h5 {
    font-size: 20px;

    ${mq('sm')} {
      font-size: 24px;
    }
  }

  h6 {
    font-size: 18px;

    ${mq('sm')} {
      font-size: 20px;
    }
  }

  img {
    margin: 0 auto;
  }

  blockquote {
    padding-left: 30px;
    border-left: 3px solid #52686c;
    white-space: pre-line;
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }

  ul,
  ol {
    display: grid;
    gap: 10px;
    padding-left: 40px;
  }

  li {
    font-weight: 300;
    padding-left: 10px;
  }

  pre {
    padding: 20px;
    overflow-x: auto;
    overflow-y: hidden;
    background-color: rgba(218, 218, 218, 0.3);
    -webkit-overflow-scrolling: touch;

    * {
      padding: 0 !important;
      border-radius: 0 !important;
      background-color: transparent !important;
    }
  }

  code {
    padding: 3px 5px 5px;
    border-radius: 4px;
    background-color: rgba(218, 218, 218, 0.3);
    font-family: monospace;
  }

  strong {
    font-weight: bold;
  }

  .gist {
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    margin-top: 8px;
  }

  &__caption {
    display: block;
    margin-top: -24px;
    color: #1a1a1a;
    font-size: 13px;
    letter-spacing: 0.54px;
    text-align: center;
  }
`
